import React from "react";
import { Flex, Box, Text, CircularProgress, CircularProgressLabel } from "@chakra-ui/react";
import Card from "components/card/Card";
import { getProjectStatusAsPercent } from "network/helper";

interface ProjectProgressProps {
  documents: any[];
}

export const ProjectProgress: React.FC<ProjectProgressProps> = ({ documents }) => {
  return (
    <Flex>
      <Card
        p="20px 16px"
        width="260px"
        height="fit-content"
        marginLeft={{ md: "auto", sm: "0px", base: "0px" }}
        marginTop={{ md: "0px", base: "0px" }}
        background="#FFF"
        boxShadow={{
          md: "0px 4px 50px rgba(0, 0, 0, 0.1)",
          base: "none",
        }}
        border={{
          md: "none",
          base: "1px solid #E9E9E9",
        }}
        borderRadius={{ md: "20px", base: "0px" }}
      >
        <Flex>
          <Box>
            <CircularProgress
              value={getProjectStatusAsPercent(documents)}
              color="green.400"
              size="110px"
              sx={{
                "svg > circle:first-of-type": {
                  stroke: "#2F80ED",
                },
              }}
              animation={"ease-in"}
            >
              <Flex>
                <CircularProgressLabel>
                  <Flex justifyContent="center">
                    <Text
                      fontSize="14px"
                      fontWeight="600"
                      color="#2F80ED"
                    >
                      {100 - getProjectStatusAsPercent(documents)}%
                    </Text>
                    <Text
                      fontSize="14px"
                      mx="5px"
                      fontStyle="italic"
                      fontWeight="500"
                    >
                      /
                    </Text>
                    <Text
                      fontSize="14px"
                      fontWeight="600"
                      color="green.400"
                    >
                      {getProjectStatusAsPercent(documents)}%
                    </Text>
                  </Flex>
                </CircularProgressLabel>
              </Flex>
            </CircularProgress>
          </Box>
          <Flex flexDir="column" justifyContent="center" ml={2}>
            <Flex alignItems="center">
              <Box w="30px" h="10px" bgColor="#2F80ED"></Box>
              <Text
                padding="2px 4px"
                fontSize="10px"
                lineHeight="135%"
                fontWeight="400"
                color="#8E8C8C"
              >
                In Progress
              </Text>
            </Flex>
            <Flex alignItems="center">
              <Box w="30px" h="10px" bgColor="green.400"></Box>
              <Text
                padding="2px 4px"
                fontSize="10px"
                lineHeight="135%"
                fontWeight="400"
                color="#8E8C8C"
              >
                Completed
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};
